import { HotkeyDisplay } from '@app/core/hotkeys/HotkeyDisplay';
import React from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';

/**
 * Returns a ReactNode for a menu tooltip: translated message only, or message with hotkey appended in parentheses.
 * Pass hotkeyKey (e.g. STREAM_HOTKEYS.get('playback', 'PLAY_PAUSE')) to show " (KEY)" after the label. If omitted or undefined, returns only the label.
 * Uses HotkeyDisplay with variant "text" for the hotkey.
 */
export function useTooltipWithHotkey(
  message: MessageDescriptor,
  hotkeyKey: string,
): React.ReactNode {
  const { $t } = useIntl();
  const label = $t(message);

  return (
    <>
      {label} (<HotkeyDisplay hotkey={hotkeyKey} variant="text" />)
    </>
  );
}
